<template>
    <div class="personalities-science-interests">
        <div class="d-flex">
            <div class="personalities-title text-left">
                Область научных интересов
            </div>
            <div class="ml-auto mt-2">
                <svg-icon
                @click="svgClick"
                :svgData="svgData"/>
            </div>
        </div>
        <div v-html="area_of_scientific_interests" v-if="this.open" class="personalities-text text-left mt-5">
        </div>
        <div class="personalities-border mt-6"></div>
    </div>
    <div class="personalities-edit" v-if="can_edit_personality">
      <v-container class="ma-0 pa-0 mt-10" fluid>
        <v-row>
            <v-col cols=12>
                <v-textarea
                    label="Область научных интересов"
                    v-model="area_of_scientific_interests_edit"
                    auto-grow>
                </v-textarea>
            </v-col>
        </v-row>
      </v-container>
    </div>
</template>
<script>

import SvgIcon from '@/components/content/SvgIcon.vue'
import { useUserStore } from '@/store/user';
import { useAuthStore } from '@/store/auth';

export default{
    name: 'PersonalitiesScienceInterests',
    components: {
        SvgIcon
    },
    data () {
            return {
                open: true,
                svgData: {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    pathArr: [{
                        d: "M23.6673 13.6668H13.6673V23.6668H10.334V13.6668H0.333984V10.3335H10.334V0.333496H13.6673V10.3335H23.6673V13.6668Z",
                        fill: "#3B66D3"
            }]
        }
      }
    },
    methods: {
        svgClick() {
            this.open=!this.open
        }
    },
    computed:{
        area_of_scientific_interests:{
            get(){
                const userStore = useUserStore()
                if (userStore.changeUser.area_of_scientific_interests)
                    return userStore.changeUser.area_of_scientific_interests
                return 'Нет'
            }
        },
        can_edit_personality() {
            const authStore = useAuthStore()
            return authStore.can_edit_personality
        },
        area_of_scientific_interests_edit:{
            get(){
                const userStore = useUserStore()
                return userStore.changeUser.area_of_scientific_interests
            },
            set(newValue){
                const userStore = useUserStore()
                userStore.changeUser.area_of_scientific_interests = newValue
            }
        }
    }
}
</script>